module.exports = __webpack_public_path__ + "img/empty.31d337a5.png";